<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.devices') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{ $ml.get('shared.definitions') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.devices') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('devices.deviceList') }} : {{ deviceList.length }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" type="button" @click="newDevice()" class="btn btn-sm btn-warning ">{{
                  $ml.get('devices.newDevice') }}</button>
              </div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                autocomplete="false" style="margin-bottom:10px;" />
              <div v-show="deviceList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table">
                  <thead>
                    <tr>
                      <th @click="setOrderDev(1)" style="cursor:pointer;">
                        <strong>
                          {{ $ml.get('devices.ipAddress') }}
                          <i v-show="orderDevice == 1" class="fa fa-sort-numeric-asc"></i>
                          <i v-show="orderDevice == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderDev(2)" style="cursor:pointer;">
                        <strong>
                          {{ $ml.get('devices.deviceName') }}
                          <i v-show="orderDevice == 3" class="fa fa-sort-alpha-asc"></i>
                          <i v-show="orderDevice == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr @click="getDevice(device1.id)" :class="device1.id == device.id ? 'bg-primary' : ''"
                      style="cursor:pointer;" v-for="device1 in deviceList" :key="device1.id">
                      <td>{{ device1.ip }}</td>
                      <td>{{ device1.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="deviceList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('devices.deviceNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary" id="deviceInfo">
            <div @click="onCloseBoxDevice()" style="cursor:pointer;" class="box-header with-border">
              <h3 class="box-title">
                <span>{{ $ml.get('devices.deviceInfo') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="form-group col-sm-3">
                  <label>{{ $ml.get('devices.deviceNumber') }}</label>
                  <input v-model="device.deviceNo" type="number" class="form-control" autocomplete="off" />
                </div>
                <div class="form-group col-sm-9">
                  <label>{{ $ml.get('devices.deviceName') }}</label>
                  <input v-model="device.name" type="text" class="form-control" autocomplete="off" />
                </div>
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('devices.brand') }}</label>
                  <select @change="changeDeviceBrand($event)" class="form-control">
                    <option :selected="device.brand == ''" value>{{ $ml.get('general.notSelected') }}</option>
                    <option :selected="device.brand == brand.brand" v-for="(brand, index) in deviceBrandList"
                      :key="index" :value="brand.brand">{{ brand.brand }}</option>
                  </select>
                </div>
                <div class="form-group col-sm-6">
                  <label>{{ $ml.get('devices.serialNo') }}</label>
                  <input v-model="device.seriNo" type="text" class="form-control" autocomplete="off" />
                </div>
                <div class="col-sm-6">
                  <div v-show="devicePlatformList.length > 0" class="form-group">
                    <label>{{ $ml.get('devices.platform') }}</label>
                    <select @change="changeDevicePlatform($event)" class="form-control">
                      <option :selected="device.platform == ''" value>{{ $ml.get('general.notSelected') }}</option>
                      <option :selected="device.platform == platform" v-for="(platform, index) in devicePlatformList"
                        :key="index" :value="platform">{{ platform }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('devices.ipAddress') }}</label>
                    <input v-model="device.ipAddress" type="text" class="form-control" autocomplete="off" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('devices.port') }}</label>
                    <input v-model="device.port" type="text" class="form-control" autocomplete="off" />
                  </div>
                  <div v-show="device.brand == 'Hikvision'" class="form-group">
                    <label>{{ $ml.get('devices.adminPassword') }}</label>
                    <input v-model="device.password" type="text" class="form-control" autocomplete="off" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('devices.status') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="device.isActive"
                          @change="device.isActive == true ? device.isActive = false : device.isActive = true"
                          type="checkbox" />
                        {{ $ml.get('general.active') }}
                      </label>
                    </span>
                  </div>
                </div>
                <div class="col-sm-6" style="margin-bottom:20px;">
                  <label>{{ $ml.get('devices.feature') }}</label>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isPanel"
                        @change="device.isPanel == true ? device.isPanel = false : device.isPanel = true"
                        type="checkbox" />
                      {{ $ml.get('devices.isPanel') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isCardDevice"
                        @change="device.isCardDevice == true ? device.isCardDevice = false : device.isCardDevice = true"
                        type="checkbox" />
                      {{ $ml.get('devices.card') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isFingerDevice"
                        @change="device.isFingerDevice == true ? device.isFingerDevice = false : device.isFingerDevice = true"
                        type="checkbox" />
                      {{ $ml.get('devices.fingerprint') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isFaceDevice"
                        @change="device.isFaceDevice == true ? device.isFaceDevice = false : device.isFaceDevice = true"
                        type="checkbox" />
                      {{ $ml.get('devices.faceRecognition') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isRealTime"
                        @change="device.isRealTime == true ? device.isRealTime = false : device.isRealTime = true"
                        type="checkbox" />
                      {{ $ml.get('devices.isRealTime') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.isOnlineDevice"
                        @change="device.isOnlineDevice == true ? device.isOnlineDevice = false : device.isOnlineDevice = true"
                        type="checkbox" />
                      {{ $ml.get('devices.isOnlineDevice') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.hasAntipassback"
                        @change="device.hasAntipassback == true ? device.hasAntipassback = false : device.hasAntipassback = true"
                        type="checkbox" />
                      {{ $ml.get('devices.hasAntipassback') }}
                    </label>
                  </span>
                  <span class="checkbox" style="margin-bottom:5px;padding-left:40px;">
                    <label>
                      <input :checked="device.hasTimeZone"
                        @change="device.hasTimeZone == true ? device.hasTimeZone = false : device.hasTimeZone = true"
                        type="checkbox" />
                      {{ $ml.get('devices.hasTimeZone') }}
                    </label>
                  </span>
                </div>
                <!--<div class="form-group col-sm-12">
                  <label>{{$ml.get('devices.deviceGroup')}}</label>
                  <select @change="changeDeviceGroup($event)" class="form-control">
                    <option selected="selected" value="0">{{$ml.get('general.select')}}</option>
                    <option
                      v-for="deviceGroup in deviceGroupList"
                      :key="deviceGroup.id"
                      :value="deviceGroup.id"
                      :selected="deviceGroup.id == device.deviceGroupId"
                    >{{deviceGroup.name}}</option>
                  </select>
                </div>-->
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button v-show="!isNewDevice && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-sil" class="btn btn-sm btn-danger " style="margin: 5px; width:120px;">{{
                    $ml.get('general.delete') }}</button>
                <button v-show="isNewDevice && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-kaydet" class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{
                    $ml.get('general.save') }}</button>
                <button v-show="!isNewDevice && authControl == 0" type="button" data-toggle="modal"
                  data-target="#modal-guncelle" class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{
                    $ml.get('general.update') }}</button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div v-show="!isNewDevice" class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">
                    <span>{{ $ml.get('devices.readerList') }}</span>
                  </h3>
                  <div class="box-tools pull-right"></div>
                </div>
                <div class="box-body">
                  <div v-show="deviceReaderList.length > 0" class="table-responsive no-padding">
                    <table class="table" style="max-height:200px;owerflow:auto;">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Okuyucu</th>
                          <th>Kapı</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr @click="getDeviceReader(deviceReader.id)"
                          :class="selectedReader.id == deviceReader.id ? 'bg-primary' : ''"
                          v-for="deviceReader in deviceReaderList" :key="deviceReader.id" style="cursor:pointer;">
                          <td style="width:40px;">{{ deviceReader.readerNo }}</td>
                          <td>{{ deviceReader.name }}</td>
                          <td>{{ deviceReader.inputName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="deviceReaderList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('devices.selectedDeviceReaderNotFound') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div v-show="!isNewDevice" class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">
                    <span>{{ $ml.get('devices.readerInformation') }}</span>
                  </h3>
                  <div class="box-tools pull-right">
                    <button v-show="authControl == 0" type="button" @click="newReader()"
                      class="btn btn-sm btn-warning ">{{ $ml.get('devices.newReader') }}</button>
                  </div>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <label>{{ $ml.get('devices.readerNo') }}</label>
                      <input v-model="selectedReader.readerNo" type="number" class="form-control" autocomplete="off" />
                    </div>
                    <div class="form-group col-sm-6">
                      <label>{{ $ml.get('devices.readerStatus') }}</label>
                      <select @change="changeReaderStatu($event)" class="form-control">
                        <option :selected="selectedReader.statu == 0" value="0">{{ $ml.get('general.notSelected') }}
                        </option>
                        <option :selected="selectedReader.statu == 1" value="1">{{ $ml.get('devices.entry') }}</option>
                        <option :selected="selectedReader.statu == 2" value="2">{{ $ml.get('devices.exit') }}</option>
                      </select>
                    </div>
                    <div class="form-group col-sm-12">
                      <label>{{ $ml.get('devices.readerName') }}</label>
                      <input v-model="selectedReader.name" type="text" class="form-control" autocomplete="off" />
                    </div>
                    <div class="form-group col-sm-12">
                      <label>{{ $ml.get('devices.inputName') }}</label>
                      <input v-model="selectedReader.inputName" type="text" class="form-control" autocomplete="off" />
                    </div>
                    <div class="form-group col-sm-12">
                    <label>{{ $ml.get('devices.isMainDoor') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="selectedReader.isMainDoor"
                          @change="selectedReader.isMainDoor == true ? selectedReader.isMainDoor = false : selectedReader.isMainDoor = true"
                          type="checkbox" />
                        {{ $ml.get('devices.isMainDoor') }}
                      </label>
                    </span>
                  </div>
                    <div class="form-group col-sm-12">
                      <label>{{ $ml.get('devices.typeOfUse') }}</label>
                      <select @change="changeReaderType($event)" class="form-control">
                        <option :selected="selectedReader.type == 0" value="0">{{ $ml.get('devices.access') }}</option>
                        <option :selected="selectedReader.type == 1" value="1">{{ $ml.get('devices.pdks') }}</option>
                        <option v-show="modules.diningHall" :selected="selectedReader.type == 2" value="2">
                          {{ $ml.get('devices.diningHall') }}</option>
                        <option v-show="modules.licencePlateRecognition" :selected="selectedReader.type == 3" value="3">
                          {{ $ml.get('devices.licencePlateRecognition') }}</option>
                        <option v-show="modules.dormitory" :selected="selectedReader.type == 5" value="5">
                          {{ $ml.get('devices.dormitoryDevice') }}</option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>X Koordinatı</label>
                        <input v-model="selectedReader.positionX" type="number" class="form-control"
                          autocomplete="off" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Y Koordinatı</label>
                        <input v-model="selectedReader.positionY" type="number" class="form-control"
                          autocomplete="off" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay" id="load" :hidden="!isLoadingReader">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer">
                  <div class="pull-left">
                    <button v-show="selectedReader.id" data-target="#qr-code" data-toggle="modal"
                      class="btn btn-sm btn-primary" style="margin:0px;">
                      <i class="fa fa-qrcode"></i> {{ $ml.get('general.viewQRCode') }}
                    </button>
                  </div>
                  <div class="pull-right">
                    <button v-show="!isNewReader && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-reader-sil" class="btn btn-sm btn-danger " style="margin: 5px;">
                      <i class="fa fa-trash"></i>
                      {{ $ml.get('general.delete') }}
                    </button>
                    <button v-show="isNewReader && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-reader-kaydet" class="btn btn-sm btn-success " style="margin: 5px;">
                      <i class="fa fa-check"></i>
                      {{ $ml.get('general.save') }}
                    </button>
                    <button v-show="!isNewReader && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-reader-guncelle" class="btn btn-sm btn-success " style="margin: 5px;">
                      <i class="fa fa-refresh"></i>
                      {{ $ml.get('general.update') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="isNewDevice" class="col-sm-12">
              <div class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('devices.readerInfo') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.device.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('devices.isContinueDeviceUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveDevice()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.device.name }}</p>
              <span>{{ $ml.get('devices.isContinueDeviceSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveDevice()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.device.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('devices.isContinueDeviceDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteDevice()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.READER MODAL START-->
      <div class="modal modal-info fade" id="modal-reader-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.selectedReader.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('devices.isContinueReaderUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveReader()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-reader-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.selectedReader.name }}</p>
              <span>{{ $ml.get('devices.isContinueReaderSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveReader()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-reader-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.selectedReader.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('devices.isContinueReaderDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deleteReader()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="maxTerminalLicence">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('shared.licenceErrorTitle') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <h4>{{ $ml.get('shared.licenceAddTerminalMaxCount') + " : " + modules.maxTerminalCount }}</h4>
              <hr />
              <span>{{ $ml.get('shared.licenceTerminalDescription') }}</span>
            </div>
            <div class="modal-footer">
              <button class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.done') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--MODALS-->
      <div class="modal fade" id="qr-code" role="dialog">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="fa fa-qrcode"></i> {{ $ml.get('general.qRCodeBarcodePrint') }}
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-8" id="print">
                  <div :style="qrTextStyle">
                    <!--QR KOD-->
                    <qrcode-vue renderAs="svg" :value="qrValue" :size="qrSize" level="H"></qrcode-vue>
                    <!--QR KOD-->
                    <div>
                      <h2 style="margin-bottom:5px;">
                        <strong>{{ selectedReader.name }}</strong>
                      </h2>
                      <span>{{ device.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <h4>{{ $ml.get('general.qrSettings') }}</h4>
                  <hr />
                  <div class="form-group">
                    <label>{{ $ml.get('general.qrSize') }}</label>
                    <input type="number" class="form-control" v-model="qrSize" />
                  </div>
                  <div class="btn-group">
                    <button @click="qrTextStyle = 'text-align:left;'" type="button"
                      :class="qrTextStyle == 'text-align:left;' ? 'btn btn-primary ' : 'btn btn-default '">
                      <i class="fa fa-align-left"></i>
                    </button>
                    <button @click="qrTextStyle = 'text-align:center;'" type="button"
                      :class="qrTextStyle == 'text-align:center;' ? 'btn btn-primary ' : 'btn btn-default '">
                      <i class="fa fa-align-center"></i>
                    </button>
                    <button @click="qrTextStyle = 'text-align:right;'" type="button"
                      :class="qrTextStyle == 'text-align:right;' ? 'btn btn-primary ' : 'btn btn-default '">
                      <i class="fa fa-align-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $ml.get('general.cancel')
                }}</button>
              <button type="button" class="btn btn-warning" @click.prevent="print()">
                <i class="fa fa-print"></i> {{ $ml.get('general.print') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--END MODALS-->
    </section>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingReader: false,
      qrValue: "",
      qrSize: 200,
      qrTextStyle: "text-align:center;",
      orderDevice: 1,
      searchText: "",
      device: {
        id: null,
        deviceNo: null,
        name: "",
        seriNo: "",
        ipAddress: "",
        port: "",
        isActive: true,
        password: "",
        deviceGroupId: null,
        readers: [],
        brand: "",
        platform: "",
        isFingerDevice: false,
        isFaceDevice: false,
        isCardDevice: false,
        hasAntipassback: false,
        hasTimeZone: false,
        isOnlineDevice: false,
        isRealTime: false,
        isPanel: false
      },
      selectedReader: {
        id: null,
        name: "",
        inputName: "",
        isMainDoor: true,
        type: 0,
        statu: "0",
        readerNo: 1,
        positionX: 0,
        positionY: 0
      },
      devices: [],
      deviceGroups: [],
      brands: [],
      platforms: [],
      selectedBrand: {
        brand: "",
        platforms: []
      },
      isNewDevice: true,
      isNewReader: true
    };
  },
  components: {
    QrcodeVue
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    deviceBrandList() {
      return this.brands;
    },
    devicePlatformList() {
      var brand = this.deviceBrandList.filter(item => item.brand == this.device.brand);
      if (brand.length > 0) {
        return brand[0].platforms;
      } else {
        return this.platforms;
      }
    },
    deviceList() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.devices.filter(item => {
          return search
            .split(" ")
            .every(
              v =>
                this.turkishToUpper(item.name).includes(v) ||
                item.ip.includes(v)
            );
        });
      } else {
        if (this.orderDevice == 1) {
          return this.devices.sort((a, b) => {
            return a.ip.localeCompare(b.ip);
          });
        } else if (this.orderDevice == 2) {
          return this.devices.sort((a, b) => {
            return b.ip.localeCompare(a.ip);
          });
        } else if (this.orderDevice == 3) {
          return this.devices.sort((a, b) => {
            return this.turkishToUpper(a.name).localeCompare(
              this.turkishToUpper(b.name)
            );
          });
        } else {
          return this.devices.sort((a, b) => {
            return this.turkishToUpper(b.name).localeCompare(
              this.turkishToUpper(a.name)
            );
          });
        }
      }
    },
    deviceGroupList() {
      return this.deviceGroups;
    },
    deviceReaderList() {
      return this.device.readers.sort((a, b) => {
        if (a.readerNo < b.readerNo) return -1;
        if (a.readerNo > b.readerNo) return 0;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    print() {
      this.$htmlToPaper("print");
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderDev(number) {
      if (number == 1) {
        if (this.orderDevice == 1) {
          this.orderDevice = 2;
        } else {
          this.orderDevice = 1;
        }
      } else {
        if (this.orderDevice == 3) {
          this.orderDevice = 4;
        } else {
          this.orderDevice = 3;
        }
      }
    },
    onCloseBoxDevice() {
      $("#deviceInfo").boxWidget("toggle");
    },
    changeDevicePlatform(event) {
      this.device.platform = event.target.value;
    },
    changeDeviceBrand(event) {
      this.device.brand = event.target.value;
      console.log(this.device.brand);
      if (this.device.brand == "ZkTeco" || this.device.brand == "ZKTeco") {
        this.device.port = 4370;
      } else if (
        this.device.brand == "Mavisoft Panel" ||
        this.device.brand == "Mavisoft MW1010"
      ) {
        this.device.port = 5600;
      } else if (this.device.brand == "Mixa") {
        this.device.port = 5000;
      } else if (this.device.brand == "Anviz") {
        this.device.port = 8080;
      } else if (this.device.brand == "Hikvision") {
        this.device.port = 8000;
      } else if (this.device.brand == "Dahua") {
        this.device.port = 37777;
      } else if (this.device.brand == "Milesight") {
        this.device.port = 6000;
      } else if (this.device.brand == "Hanvon") {
        this.device.port = 8000;
      } else if (this.device.brand == "Soyal") {
        this.device.port = 6000;
      }
    },
    changeDeviceGroup(event) {
      this.device.deviceGroupId = event.target.value;
    },
    changeReaderType(event) {
      this.selectedReader.type = event.target.value;
    },
    changeReaderStatu(event) {
      this.selectedReader.statu = event.target.value;
    },
    async newDevice() {
      this.isLoadingDetail = true;
      this.isNewDevice = true;
      this.device.id = null;
      const response = await this.$axios.get("/Terminal/GetNewDeviceNo");
      this.device.deviceNo = response.data;
      this.device.seriNo = "";
      this.device.name = "";
      this.device.ipAddress = "";
      this.device.port = "";
      this.device.isActive = true;
      this.device.password = "";
      this.device.deviceGroupId = null;
      this.device.readers = [];
      this.device.brand = "";
      this.device.platform = "";
      this.device.isFingerDevice = false;
      this.device.isFaceDevice = false;
      this.device.isCardDevice = false;
      this.device.hasAntipassback = false;
      this.device.hasTimeZone = false;
      this.device.isOnlineDevice = false;
      this.device.isRealTime = false;
      this.device.isPanel = false;
      this.newReader();
      this.isLoadingDetail = false;
    },
    async newReader() {
      this.isLoadingReader = true;
      this.isNewReader = true;
      this.selectedReader.id = null;
      this.selectedReader.name = "";
      this.selectedReader.inputName = "";
      this.selectedReader.isMainDoor = true;
      this.selectedReader.type = 0;
      this.selectedReader.statu = 0;
      this.selectedReader.positionX = 0;
      this.selectedReader.positionY = 0;
      this.qrValue = "";
      if (this.device.id) {
        const response = await this.$axios.get(
          "/Terminal/GetNewReaderNo?parentDeviceId=" + this.device.id
        );
        this.selectedReader.readerNo = response.data;
      } else {
        this.selectedReader.readerNo = 1;
      }
      this.isLoadingReader = false;
    },
    async deleteReader() {
      if (this.isNewReader) {
        alertify.warning(this.$ml.get("alerts.pleaseSelectReader"));
      } else {
        this.isLoadingReader = true;
        try {
          let id = this.selectedReader.id;
          const response = await this.$axios
            .delete("/Terminal/DeleteReader/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReader = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReader = false;
                  return;
                }
              }
            });
          this.getDevice(this.device.id);
          this.newReader();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingReader = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingReader = false;
        }
      }
    },
    async saveReader() {
      if (this.selectedReader.name == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAReaderName"));
        return;
      }
      if (this.selectedReader.readerNo == "") {
        alertify.warning(
          this.$ml.get("alerts.pleaseReaderNoOrPressButtonNewReader")
        );
        return;
      }
      this.isLoadingReader = true;
      if (this.isNewReader) {
        try {
          let reader2 = this.selectedReader;
          let deviceId = this.device.id;
          const response = await this.$axios
            .post("/Terminal/AddReader", {
              name: reader2.name,
              inputName: reader2.inputName,
              isMainDoor: reader2.isMainDoor,
              parentDeviceId: parseInt(deviceId),
              doorType: parseInt(reader2.type),
              readerNo: parseInt(reader2.readerNo),
              inOut: parseInt(reader2.statu),
              positionX: parseFloat(reader2.positionX),
              positionY: parseFloat(reader2.positionY)
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReader = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReader = false;
                  return;
                }
              }
            });
          let id = response.data.okuyucuId;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDevice(deviceId);
          this.getDeviceReader(id);
          this.isNewReader = false;
          this.isLoadingReader = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingReader = false;
        }
      } else {
        //GÜNCELLE
        try {
          let reader2 = this.selectedReader;
          let deviceId = this.device.id;
          const response = await this.$axios
            .post("/Terminal/UpdateReader/" + reader2.id, {
              name: reader2.name,
              inputName: reader2.inputName,
              isMainDoor: reader2.isMainDoor,
              parentDeviceId: parseInt(deviceId),
              doorType: parseInt(reader2.type),
              readerNo: parseInt(reader2.readerNo),
              inOut: parseInt(reader2.statu),
              positionX: parseFloat(reader2.positionX),
              positionY: parseFloat(reader2.positionY)
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReader = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReader = false;
                  return;
                }
              }
            });
          let id = response.data.okuyucuId;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDevice(deviceId);
          this.getDeviceReader(id);
          this.isLoadingReader = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingReader = false;
        }
      }
    },
    async deleteDevice() {
      try {
        this.isLoadingDetail = true;
        let id = this.device.id;
        const response = await this.$axios
          .delete("/Terminal/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getDevices();
        this.newDevice();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveDevice() {
      if (this.device.deviceNo == "" || this.device.deviceNo == null) {
        alertify.warning(this.$ml.get("alerts.pleaseEnterADeviceNo"));
        return;
      }
      if (this.device.name == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterADeviceName"));
        return;
      }
      if (this.device.ipAddress == "" || this.device.port == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterIpAddressAndPort"));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewDevice) {
        if (this.deviceList.length >= this.modules.maxTerminalCount) {
          this.isLoadingDetail = false;
          $("#maxTerminalLicence").modal("show");
          return;
        }
        try {
          let device2 = this.device;
          const response = await this.$axios
            .post("/Terminal", {
              name: device2.name,
              deviceNo: parseInt(device2.deviceNo),
              seriNo: device2.seriNo,
              ipAddress: device2.ipAddress,
              port: device2.port,
              isActive: device2.isActive,
              password: device2.password,
              deviceGroupId: parseInt(device2.deviceGroupId),
              brand: device2.brand,
              platform: device2.platform,
              isFingerDevice: device2.isFingerDevice,
              isCardDevice: device2.isCardDevice,
              isFaceDevice: device2.isFaceDevice,
              hasAntiPassback: device2.hasAntipassback,
              hasTimeZone: device2.hasTimeZone,
              isOnlineDevice: device2.isOnlineDevice,
              isRealTime: device2.isRealTime,
              isPanel: device2.isPanel
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.terminalId;
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDevices();
          this.getDevice(id);
          this.isNewDevice = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let device2 = this.device;
          const response = await this.$axios
            .post("/Terminal/" + device2.id, {
              name: device2.name,
              deviceNo: parseInt(device2.deviceNo),
              seriNo: device2.seriNo,
              ipAddress: device2.ipAddress,
              port: device2.port,
              isActive: device2.isActive,
              password: device2.password,
              deviceGroupId: device2.deviceGroupId,
              brand: device2.brand,
              platform: device2.platform,
              isFingerDevice: device2.isFingerDevice,
              isCardDevice: device2.isCardDevice,
              isFaceDevice: device2.isFaceDevice,
              hasAntiPassback: device2.hasAntipassback,
              hasTimeZone: device2.hasTimeZone,
              isOnlineDevice: device2.isOnlineDevice,
              isRealTime: device2.isRealTime,
              isPanel: device2.isPanel
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getDevices();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getDevice(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/Terminal/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isNewDevice = false;
        this.device.id = id;
        this.device.deviceNo = response.data.deviceNo;
        this.device.seriNo = response.data.seriNo;
        this.device.name = response.data.name;
        this.device.ipAddress = response.data.ipAddress;
        this.device.port = response.data.port;
        this.device.isActive = response.data.isActive;
        this.device.password = response.data.password;
        this.device.deviceGroupId = response.data.deviceGroupId;
        this.device.readers = response.data.readers;
        this.device.brand = response.data.brand;
        if (response.data.brand == "Superpass") {
          this.device.brand = "Mixa";
        }
        this.device.platform = response.data.platform;
        this.device.isFingerDevice = response.data.isFingerDevice;
        this.device.isFaceDevice = response.data.isFaceDevice;
        this.device.isCardDevice = response.data.isCardDevice;
        this.device.hasAntipassback = response.data.hasAntiPassback;
        this.device.hasTimeZone = response.data.hasTimeZone;
        this.device.isOnlineDevice = response.data.isOnlineDevice;
        this.device.isRealTime = response.data.isRealTime;
        this.device.isPanel = response.data.isPanel;
        if (this.device.readers.length != 0) {
          let dd = this.device.readers[0].id;
          this.getDeviceReader(dd);
        } else {
          this.newReader();
        }
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getDeviceReader(id) {
      try {
        this.isLoadingReader = true;
        const response = await this.$axios
          .get("/Terminal/GetReader/" + id)
          .then(response => {
            this.isNewReader = false;
            this.selectedReader.id = id;
            this.selectedReader.readerNo = response.data.readerNo;
            this.selectedReader.name = response.data.name;
            this.selectedReader.inputName = response.data.inputName;
            this.selectedReader.isMainDoor = response.data.isMainDoor;
            this.selectedReader.type = response.data.doorType;
            this.selectedReader.statu = response.data.inOut;
            this.selectedReader.positionX = response.data.positionX;
            this.selectedReader.positionY = response.data.positionY;
            this.qrValue = "TCRP-" + id;
            this.isLoadingReader = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingReader = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingReader = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingReader = false;
      }
    },
    async getDevices() {
      try {
        this.isLoading = true;
        const devices = [];
        const response = await this.$axios
          .get("/Terminal")
          .then(response => {
            response.data.forEach(doc => {
              devices.push({
                id: doc.id,
                no: doc.no,
                name: doc.name,
                ip: doc.ip
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.devices = devices;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async GetBrandsAndPlatforms() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("/Terminal/GetBrandsAndPlatforms")
          .then(response => {
            this.brands = response.data;
            this.device.brand = this.brands[0].brand;
            this.device.platform = this.brands[0].platforms[0];
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getDeviceGroups() {
      try {
        this.isLoadingDetail = true;
        const deviceGroups = [];
        const response = await this.$axios
          .get("/TerminalGroups")
          .then(response => {
            response.data.forEach(doc => {
              deviceGroups.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.deviceGroups = deviceGroups;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDevices();
    await this.getDeviceGroups();
    await this.GetBrandsAndPlatforms();
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/devices/Devices.vue